module.exports = __webpack_public_path__ + "img/Sanitätsgruppe.7d7be063.svg";